<template>
  <v-container pa-0 my-3>
    <p class="display-36-24 primary--text mb-1">המשרות החמות שלנו</p>
    <v-row
      id="companies-banner-section"
      class="mx-0 mb-8"
      :class="$vuetify.breakpoint.xs ? 'py-3' : 'py-7'"
      v-if="hotJobsLength > 0"
    >
    
      <HotJobItem :item="item" v-for="(item, index) in hotJobs" :key="index" :is-load-more-banner="isLoadMoreBanner" />

      <HotJobBanner 
        v-show="displayHotJobBanner"
        :display="displayHotJobBanner"
      />
    </v-row>

    <v-row v-else id="companies-banner-section2" class="mx-0 mb-8">
      <NoHotJobsBanner v-show="hotJobs.length == 0" />
    </v-row>
  </v-container>
</template>

<script>
import HotJobItem from '@/components/Jobs_List/Company_Banner/HotJobItem';
import HotJobBanner from '@/components/Jobs_List/Company_Banner/HotJobBanner';
import NoHotJobsBanner from '@/components/Jobs_List/Company_Banner/NoHotJobsBanner';

export default {
  components: {
    HotJobItem,
    HotJobBanner,
    NoHotJobsBanner,
  },

  props: {
    hotJobs: {
      type: Array,
      required: false,
      default: () => [],
    },
    isLoadMoreBanner: {
      type: Boolean,
      required: false,
      default: false
    },
    maxJobs: {
      type: Number,
      required: false,
    }
  },

  computed: {
    hotJobsLength() {
      return this.hotJobs.length;
    },
    displayHotJobBanner() {
      return this.hotJobsLength < this.maxJobs && this.hotJobsLength > 0;
    }
  },
};
</script>

<style lang="scss" scoped>
#companies-banner-section {
  flex-wrap: nowrap;
  overflow: auto;
  justify-content: space-between;
  @media only screen and (min-width: 968px) {
    justify-content: center;
  }
}
#companies-banner-section2 {
  box-shadow: 0 0 15px #cfcdcd;
  flex-wrap: nowrap;
  overflow: auto;
  justify-content: space-between;
  @media only screen and (min-width: 600px) {
    box-shadow: 0 0 15px #cfcdcd;
  }
  @media only screen and (min-width: 968px) {
    justify-content: center;
  }
}

@media only screen and (max-width: 600px) {
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
